import { selfAxios } from "../../../../../../../axios/selfAxios.js";
async function opGetGetDict(params) {
  const res = await selfAxios.get(`/ucenterapi/uc/internal/dict/getDict`, { params, _cache: true });
  return res.data;
}
export { opGetGetDict };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/request/ucenterapi/ucenterapi/uc/internal/dict/getDict/get.js